import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatures } from '../hooks/useFeatures.ts';
import { useIsAdmin } from '../hooks/useIsAdmin.ts';

const FeatureProtectedRoute = ({ children, requiredFeature, fallbackPath = '/upgrade' }) => {
  const { features, isLoading } = useFeatures();
  const isAdmin = useIsAdmin();

  // Show loading state while checking features
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Use the same logic as Layout.js isFeatureLocked function
  const isFeatureLocked = (featureName) => {
    if (isLoading) return false; // Don't lock features while loading
    if (!features.includes(featureName)) return true;
    return false;
  };

  // Check if the required feature is locked
  const isLocked = isFeatureLocked(requiredFeature);

  // If feature is locked, redirect to upgrade page
  if (isLocked) {
    return <Navigate to={fallbackPath} replace />;
  }

  // If feature is available, render the children
  return children;
};

export default FeatureProtectedRoute; 